import type * as Types from '~/api/schema.graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CommentThreadsListQueryVariables = Types.Exact<{
  resourceId: Types.Scalars['ID']['input'];
  input?: Types.InputMaybe<Types.CommentThreadListInput>;
}>;


export type CommentThreadsListQuery = { readonly commentable: (
    { readonly __typename?: 'InternshipEngagement' }
    & Pick<Types.InternshipEngagement, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'InternshipProject' }
    & Pick<Types.InternshipProject, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'Language' }
    & Pick<Types.Language, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'LanguageEngagement' }
    & Pick<Types.LanguageEngagement, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'MomentumTranslationProject' }
    & Pick<Types.MomentumTranslationProject, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'MultiplicationTranslationProject' }
    & Pick<Types.MultiplicationTranslationProject, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'Partner' }
    & Pick<Types.Partner, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'ProgressReport' }
    & Pick<Types.ProgressReport, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) | (
    { readonly __typename?: 'User' }
    & Pick<Types.User, 'id'>
    & { readonly commentThreads: (
      { readonly __typename?: 'CommentThreadList' }
      & Pick<Types.CommentThreadList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
      & { readonly items: ReadonlyArray<(
        { readonly __typename?: 'CommentThread' }
        & Pick<Types.CommentThread, 'id' | 'createdAt'>
        & { readonly firstComment: (
          { readonly __typename?: 'Comment' }
          & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
          & { readonly body: (
            { readonly __typename?: 'SecuredRichText' }
            & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
          ), readonly creator: (
            { readonly __typename?: 'User' }
            & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
          ) }
        ), readonly comments: (
          { readonly __typename?: 'CommentList' }
          & Pick<Types.CommentList, 'canCreate' | 'total' | 'hasMore' | 'nextPage'>
          & { readonly items: ReadonlyArray<(
            { readonly __typename?: 'Comment' }
            & Pick<Types.Comment, 'id' | 'createdAt' | 'modifiedAt' | 'canDelete'>
            & { readonly body: (
              { readonly __typename?: 'SecuredRichText' }
              & Pick<Types.SecuredRichText, 'value' | 'canEdit' | 'canRead'>
            ), readonly creator: (
              { readonly __typename?: 'User' }
              & Pick<Types.User, 'id' | 'fullName' | 'avatarLetters'>
            ) }
          )> }
        ) }
      )> }
    ) }
  ) };


export const CommentThreadsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentThreadsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentThreadListInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentThreads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canCreate"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"commentThread"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pagination"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarLetters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pagination"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"commentThread"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommentThread"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canCreate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pagination"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]} as unknown as DocumentNode<CommentThreadsListQuery, CommentThreadsListQueryVariables>;